/**
 * Vendor
 */
import React from 'react';

/**
 * CARIBE7 MODULES
 */
import BaseAlertService from '@shared/services/base/alerts/BaseAlertService';

/**
 * Success Alert Service
 *
 * @class      SuccessAlertService (name)
 */
function SuccessAlertService(component) {
  this.component   = component;
}

SuccessAlertService.prototype = Object.assign(SuccessAlertService.prototype, BaseAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
SuccessAlertService.prototype.registerSuccessAlertEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.SUCCESS_DISPLAY] = 'onSuccesDisplay';
  event_callback_map[this.event_group.SUCCESS_SUCCESS] = 'onSuccesSuccess';
  event_callback_map[this.event_group.SUCCESS_FAIL]    = 'onSuccesFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
SuccessAlertService.prototype.removeSuccessAlertEvents = function() {
  this.removeEvents([
    this.event_group.SUCCESS_DISPLAY,
    this.event_group.SUCCESS_SUCCESS,
    this.event_group.SUCCESS_FAIL
  ]);
  return this;
}


/**
 * Called when success alert display
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
SuccessAlertService.prototype.onSuccesDisplay = function({
  title='Success',
  message='',
  options={},
  onConfirm,
  onResolve,
  onError
}) {
  this.createSwal({
    props: {
      title:   <span>{title}</span>,
      html:    <span>{message}</span>,
      icon:    'success',
    },
    options:   options,
    onConfirm: onConfirm,
    onResolve: onResolve,
    onError:   onError,
  });
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
SuccessAlertService.prototype.onSuccesSuccess = function(response) {
  console.log("SuccessAlertService::onSuccesSuccess", response);
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
SuccessAlertService.prototype.onSuccesFail = function(error) {
  console.log("SuccessAlertService::onSuccesFail", error);
}

export default SuccessAlertService;